<div class="flex flex-col min-h-screen">
  <prism-header class=" top-0 z-10"></prism-header>
  <div class="container mx-auto container-pad">
    <router-outlet></router-outlet>
  </div>
  <prism-footer class="bottom-0 z-0 mt-auto"></prism-footer>
</div>
<prism-spinner></prism-spinner>

